/* eslint-disable jsx-a11y/anchor-is-valid */

import * as React from "react";
import { TicketConversation, TicketPrivateConversation} from "../../http/protocol";
import { TicketComp} from "./TicketComp";
import { TextareaAutosize } from "@material-ui/core";

export enum NoteType {
    PRIVATE = "PRIVATE",
    PUBLIC = "PUBLIC"
}

interface Props {
    ticket_id : string;
    notes?: TicketConversation[] | TicketPrivateConversation[];
    title: string;
    expanded?: boolean;
    noteType?: NoteType;
    ticketLastReviewed?: Date;
    addComment: (comment: string) => void;
    deleteComment: (id: string) => void
}
interface State {
    ready?: boolean;
    notes?: TicketConversation[] | TicketPrivateConversation[];
    comment?: string;
    addingComment?: boolean;
    expanded?: boolean;
}

export class TicketsNotesConversation extends React.Component<Props,State>{

    constructor(props : Props) {
        super(props);
        this.state = { ready : true, notes : props.notes || [], comment : "", addingComment : false, expanded : this.props.expanded };
    }

    onChange(e : any) {
        this.setState({ comment : e.target.value });
    }

    componentDidUpdate(prevProps: Props, prevState: State){
        if (prevProps.notes !== this.props.notes) {
            this.setState({notes:this.props.notes})
        }

    }

    addComment(e : any) {
        e.preventDefault();

        if (this.state.comment && this.state.comment.length !== 0 && this.state.comment.trim().length !== 0) {
            this.setState({ comment : "", addingComment : true})
            this.setState({ addingComment : false})
            this.props.addComment(this.state.comment);
        }

    }

    render() {
 
        if(!this.state.ready || !this.state.notes) {
            return <span/>
        }

        
        let totalNodes = this.state.notes && this.state.notes.length;

        let noteTypeStyle = this.props.noteType === NoteType.PRIVATE ? {backgroundColor:"#D3D3D3"} : undefined;

        return (
           
            
            <div className="card-box expandable-box" style={noteTypeStyle}>

                {this.state.expanded && (
                    <a  className="expand-button float-right" onClick={()=>this.setState({expanded : false})}><i className="mdi mdi-minus"></i></a>
                )}
                {!this.state.expanded && (
                    <a  className="expand-button float-right" onClick={()=>this.setState({expanded : true})}><i className="mdi mdi-plus"></i></a>
                )}

                <h4 className="header-title mb-3" onClick={()=>this.setState({expanded : !this.state.expanded})}>{this.props.title}    <span className="badge badge-danger badge-pill ">{this.state.notes.length}</span></h4>

                {(this.state.expanded) && (
                    <div className="chat-conversation">
                        <div className="slimScrollDiv">
                            <ul className="conversation-list" style={{overflowY : "scroll"}}>
                                {this.state.notes.map( (note,index) => (
                                    <TicketComp 
                                        deleteComment={(id: string) => { this.props.deleteComment(id) }} 
                                        canDelete={false}
                                        isReviewed={this.props.ticketLastReviewed && this.props.ticketLastReviewed >= note.timestamp!} 
                                        note={note} 
                                        key={"note"+note.id} 
                                        show={(this.state.expanded)? true: false} 
                                    />
                                ))}
                            </ul>
                            <div className="slimScrollBar"
                            ></div>
                            <div className="slimScrollRail"
                            ></div>
                        </div>

                    </div>
                )}
                
                                    

                {this.state.expanded && (
                    <div className="chat-conversation">
                        <form onSubmit={(e) => this.addComment(e)}>
                            <div className="row">
                                <div className="col">
                                    <TextareaAutosize value={this.state.comment} onChange={(e) => this.onChange(e)} className="form-control chat-input" placeholder="Enter your text"/>
                                </div>
                                <div className="col-auto">
                                    <button type="submit" className="btn btn-danger chat-send btn-block waves-effect waves-light">Add Comment
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                )}
            </div>
        )
    }
}
